import React from 'react';

export default function DashboardSettings() {
    return (
        <div>
            <h1>Dashboard Settings</h1>
            <p>This is the Settings section of the dashboard.</p>
        </div>
    );
}